import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MFQ } from 'src/app/shared/models/exercise.model';
import { UtilityService } from 'src/app/shared/utils/utility.service';
// import { MFQ } from 'src/app/models/exercise.model';
// import { UtilityService } from 'src/app/services/utility.service';
@Component({
  selector: 'app-mfq',
  templateUrl: './mfq.component.html',
  styleUrls: ['./mfq.component.css']
})
export class MfqComponent implements OnInit {
  nextButton: boolean = false;
  @Input() showBackButton: boolean = false;
  _element: MFQ;
  _answer: any;
  answerMap: any = {};
  @Input() fixedEditor: any;
  @Input() index: number;
  @Input() exerciseTimetrackingdata;
  @Input() userFeedback;
  @Output() reportFeedback = new EventEmitter<Object>();
  @Output() likeDislike = new EventEmitter<boolean>();
  @Input() set answer(answer) {
    if (answer) {
      this._answer = answer;
      this.questionChecked = true;
    }
  }
  @Input() isResultPublished: boolean = false;
  @Input() points: any;
  @Input() variableFeedback: any;
  @Input() id: string;
  @Input() correctAnswers;
  @Input() isSubmitted: boolean = false;
  @Input() immediateFeedBackRequired: boolean = false;
  @Output() valueChanged = new EventEmitter();
  @Output() onReview = new EventEmitter();
  @Output() back = new EventEmitter<Boolean>(false);
 
  
  questionChecked: boolean = false;
  @Input()
  set element(element) {
    this._element = element;
  }

  @Input() exerciseId;
  @Input() questionBlos;

  constructor(private utilitiyService :UtilityService) { }

  ngOnInit() {
  }

  next() {
    this.valueChanged.emit({ elementId: this.id, answer: JSON.stringify(this.answerMap) });
  }

  backHandler() {
    this.back.emit(true);
  }
  nextButtonHandler(event) {
    this.nextButton = event.nextButton
    this.answerMap = event.map
  }
  get questionAttempted() {
    return this.nextButton;
  }
  check() {
    let obj = { elementId: this.id, answer: JSON.stringify(this.answerMap) }
    this.utilitiyService.evaluateQuestion({ exerciseId: this.exerciseId, answers: obj }).subscribe(data => {
      if (data) {
        this.variableFeedback = data.answerFeedback
        this.questionChecked = true;
        this.onReview.emit(obj);
      }
    });
  }
  
  skip() {
    this.valueChanged.emit({ elementId: this.id, answer: '' });
  }

  _reportFeedback() {
    this.reportFeedback.emit(this._element);
  }

  _likeDislike(like) {
    this.likeDislike.emit(like);
  }
}
